import React from 'react';
import type { SurveyPage } from '../../../types/publicForm.types';
import { FormSection } from './FormSection';

interface FormPageProps {
  page: SurveyPage;
  primaryColor: string;
}

export const FormPage: React.FC<FormPageProps> = ({ page, primaryColor }) => {
  return (
    <div className="space-y-6">
      {/* Page Title and Description */}
      {(page.title || page.description) && (
        <div className="bg-[#fffffff7] rounded-lg shadow-lg p-6 mb-6">
          {page.title && (
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              {page.title}
            </h2>
          )}
          {page.description && (
            <div
              className="prose prose-sm max-w-none text-gray-700"
              dangerouslySetInnerHTML={{ __html: page.description }}
            />
          )}
        </div>
      )}

      {/* Form Sections */}
      {page.surveySections
        ?.filter(section => section.state === 'active')
        .map((section, index, activeSections) => (
          <div
            key={section.id}
            className={index === activeSections.length - 1 ? "" : ""}
          >
            <FormSection
              section={section}
              primaryColor={primaryColor}
            />
          </div>
        ))}
    </div>
  );
};